import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { InfoMessageComponent } from './info-message.component';


@NgModule({
  declarations: [
    InfoMessageComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    InfoMessageComponent
  ]
})
export class InfoMessageModule { }
